import { ref } from "vue";

export const isSettingsDialogOpen = ref(false);